import React from 'react';
import styled from 'styled-components/macro';
import FetchingAnimation from './fetching.gif';

export enum FetLoaderSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

const generateSize = (size: FetLoaderSize): string => {
  switch (size) {
    case FetLoaderSize.Large:
      return `      
      min-width: 250px;
      min-height: 250px;
      max-width: 250px;
      max-height: 250px;
      `;
    case FetLoaderSize.Medium:
      return `
      min-width: 150px;
      min-height: 150px;
      max-width: 150px;
      max-height: 150px;
        `;
    case FetLoaderSize.Small:
      return `
      min-width: 100px;
      min-height: 100px;
      max-width: 100px;
      max-height: 100px;
        `;
    default:
      return `
        width: 350px;
        height: 350px;
        `;
  }
};

interface IFetchLoaderProps {
  size: FetLoaderSize;
}

const FetchLoader = ({ size }: IFetchLoaderProps): JSX.Element => {
  return <Animation size={generateSize(size)} />;
};

export default FetchLoader;

const Animation = styled.div<{ size: string }>`
  display: flex;
  ${({ size }): string => size}
  padding: 20px;
  border-radius: 50%;
  background-image: url(${FetchingAnimation});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
